import MessageBroker from '@Services/MessageBroker';
import RxSocket from '@Services/RxSocket';
import UserDatabases from '@Services/UserDatabases';
import Breadcrumb from '@Services/Breadcrumb';
import { RxSocketUrls } from '@Constants/CommonConstants';
import SimpleTmpl from '@Services/SimpleTmpl';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { preprocessQueryletsResponse } from '@Services/FeatureSwitchResponsePreprocessors';
import AppStorage from '@Services/AppStorage';
import omit from 'lodash/omit';
import map from 'lodash/map';
import range from 'lodash/range';

const operators = {};
const CANСELLED_SEARCH_KEY = 'CANCELLED_SEARCH_REQUEST_IDS';
const TYPEAHEADS_OMIT_PROPS = ['analytics'];

export const getSearchProperties = async () => {
  const response = await MessageBroker.send(RequestUrls.searchBuilder);
  return preprocessQueryletsResponse(response);
};

export const searchByQuery = (queryStr, Typeaheads, structure, searchId, requestId, options) => {
  Breadcrumb.resetBreadcrumbs();
  const databaseIds = UserDatabases.getListWithIds();
  const chunk = {
    databases: databaseIds,
  };
  Object.assign(
    chunk,
    queryStr && { content: queryStr.replace(/\u00A0/g, ' ') },
    Typeaheads && { Typeaheads: map(Typeaheads, (typeahead) => omit(typeahead, TYPEAHEADS_OMIT_PROPS)) },
    structure && { structure },
    { searchId },
    requestId && { requestId },
    options && { options }
  );
  return RxSocket.send(RxSocketUrls.QuickSearchUrl, chunk);
};

export const cancelSearch = (searchId, requestId) => {
  // eslint-disable-next-line no-use-before-define
  storeCancelledSearch(requestId);
  return RxSocket.send(
    SimpleTmpl.format(RxSocketUrls.CancelSearch, {
      searchId,
    })
  );
};

const storeCancelledSearch = (requestId) => {
  const cancelledRequests = AppStorage.instance.getFromSessionStorage(CANСELLED_SEARCH_KEY) || [];
  AppStorage.instance.setToSessionStorage(CANСELLED_SEARCH_KEY, [...cancelledRequests, requestId]);
};

export const removeCancelledSearch = (requestId) => {
  const cancelledRequests = AppStorage.instance.getFromSessionStorage(CANСELLED_SEARCH_KEY) || [];
  const updatedRequestIds = cancelledRequests.filter((id) => id !== requestId);
  AppStorage.instance.setToSessionStorage(CANСELLED_SEARCH_KEY, updatedRequestIds);
};

export const isSearchCancelled = (requestId) => {
  const cancelledRequests = AppStorage.instance.getFromSessionStorage(CANСELLED_SEARCH_KEY) || [];
  return cancelledRequests.includes(requestId);
};

export const cancelQuery = (queryId) => {
  return RxSocket.send(
    SimpleTmpl.format(RxSocketUrls.CancelQuery, {
      queryId,
    })
  );
};

export const getForms = () => {
  return MessageBroker.send(RequestUrls.forms, null, { cache: false });
};

export const getExistingOperators = (type) => {
  if (!operators[type]) {
    return MessageBroker.send(RequestUrls[type])
      .then((data) => {
        operators[type] = data;
        return operators[type];
      })
      .catch(Logger.error);
  }
  return Promise.resolve(operators[type]);
};

export const getExistingBoundOperators = () => {
  return getExistingOperators('boundOperators');
};

export const getExistingLogicOperators = () => {
  return getExistingOperators('logicOperators')
    .then(
      (data) =>
        data &&
        data.map((op) =>
          op.supportsQualifier
            ? {
                ...op,
                operatorQualifiers: range(op.lowerQualifierBound, op.upperQualifierBound + 1),
              }
            : op
        )
    )
    .catch(Logger.reject);
};
